module.exports = __webpack_public_path__ + "img/bg.8deb9fb1.jpg";